module.exports = __webpack_public_path__ + "media/images/flags/SZ-e327f25a6c56e16f35e3a2696026775a.svg";